"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/dashboard/v1/cms_common.proto (package spwn.dashboard.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSDashboardGoodsVariant = exports.CMSDashboardGoods = exports.CMSDashboardPlan = exports.CMSDashboardGraphComment = exports.CMSDashboardGraph = exports.CMSDashboardPurchaseAmountHistogram = exports.CMSDashboardPurchaseAmountHistogramBin = exports.CMSDashboardGenderAgeHistogram = exports.CMSDashboardGenderAgeHistogramBin = exports.CMSDashboardGraphConsecutivePeriodHistogram = exports.CMSDashboardConsecutivePeriodHistogramBin = exports.CMSDashboardGraphTimeSeries = exports.CMSDashboardGraphTimeSeriesValue = exports.CMSDashboardGraphGroup = exports.CMSDashboardYoutubeAccount = exports.CMSDashboardCommentLinkId = exports.CMSDashboardGraphCommentColor = exports.CMSDashboardGraphId = exports.CMSDashboardGraphGroupId = exports.CMSDashboardGraphPurchaseAmountType2 = exports.CMSDashboardGraphPurchaseAmount = exports.CMSDashboardGraphConsecutivePeriod = exports.CMSDashboardGraphAgeGroup = exports.CMSDashboardGraphGender = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphGender
 */
var CMSDashboardGraphGender;
(function (CMSDashboardGraphGender) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GENDER_UNSPECIFIED = 0;
     */
    CMSDashboardGraphGender[CMSDashboardGraphGender["CMS_DASHBOARD_GRAPH_GENDER_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_GENDER_UNSPECIFIED";
    /**
     * 男性のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GENDER_MALE = 1;
     */
    CMSDashboardGraphGender[CMSDashboardGraphGender["CMS_DASHBOARD_GRAPH_GENDER_MALE"] = 1] = "CMS_DASHBOARD_GRAPH_GENDER_MALE";
    /**
     * 女性のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GENDER_FEMALE = 2;
     */
    CMSDashboardGraphGender[CMSDashboardGraphGender["CMS_DASHBOARD_GRAPH_GENDER_FEMALE"] = 2] = "CMS_DASHBOARD_GRAPH_GENDER_FEMALE";
    /**
     * その他のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GENDER_OTHER = 3;
     */
    CMSDashboardGraphGender[CMSDashboardGraphGender["CMS_DASHBOARD_GRAPH_GENDER_OTHER"] = 3] = "CMS_DASHBOARD_GRAPH_GENDER_OTHER";
})(CMSDashboardGraphGender = exports.CMSDashboardGraphGender || (exports.CMSDashboardGraphGender = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphGender)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphGender, "spwn.dashboard.v1.CMSDashboardGraphGender", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_GENDER_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_GENDER_MALE" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_GENDER_FEMALE" },
    { no: 3, name: "CMS_DASHBOARD_GRAPH_GENDER_OTHER" },
]);
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphAgeGroup
 */
var CMSDashboardGraphAgeGroup;
(function (CMSDashboardGraphAgeGroup) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_UNSPECIFIED = 0;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_UNSPECIFIED";
    /**
     * 12歳以下のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_UNDER_12 = 1;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_UNDER_12"] = 1] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_UNDER_12";
    /**
     * 13~17歳のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_13_TO_17 = 2;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_13_TO_17"] = 2] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_13_TO_17";
    /**
     * 18~24歳のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_18_TO_24 = 3;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_18_TO_24"] = 3] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_18_TO_24";
    /**
     * 18~24歳のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_25_TO_34 = 4;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_25_TO_34"] = 4] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_25_TO_34";
    /**
     * 25~34歳のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_35_TO_44 = 5;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_35_TO_44"] = 5] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_35_TO_44";
    /**
     * 45~54歳のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_45_TO_54 = 6;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_45_TO_54"] = 6] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_45_TO_54";
    /**
     * 55~64歳のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_55_TO_64 = 7;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_55_TO_64"] = 7] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_55_TO_64";
    /**
     * 65歳以上のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_AGE_GROUP_OVER_65 = 8;
     */
    CMSDashboardGraphAgeGroup[CMSDashboardGraphAgeGroup["CMS_DASHBOARD_GRAPH_AGE_GROUP_OVER_65"] = 8] = "CMS_DASHBOARD_GRAPH_AGE_GROUP_OVER_65";
})(CMSDashboardGraphAgeGroup = exports.CMSDashboardGraphAgeGroup || (exports.CMSDashboardGraphAgeGroup = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphAgeGroup)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphAgeGroup, "spwn.dashboard.v1.CMSDashboardGraphAgeGroup", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_UNDER_12" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_13_TO_17" },
    { no: 3, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_18_TO_24" },
    { no: 4, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_25_TO_34" },
    { no: 5, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_35_TO_44" },
    { no: 6, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_45_TO_54" },
    { no: 7, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_FROM_55_TO_64" },
    { no: 8, name: "CMS_DASHBOARD_GRAPH_AGE_GROUP_OVER_65" },
]);
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphConsecutivePeriod
 */
var CMSDashboardGraphConsecutivePeriod;
(function (CMSDashboardGraphConsecutivePeriod) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_UNSPECIFIED = 0;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_UNSPECIFIED";
    /**
     * 継続期間が1ヶ月未満のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_LESS_THAN_1 = 1;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_LESS_THAN_1"] = 1] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_LESS_THAN_1";
    /**
     * 継続期間が1ヶ月のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_1 = 2;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_1"] = 2] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_1";
    /**
     * 継続期間が2~3ヶ月のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_2_TO_3 = 3;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_2_TO_3"] = 3] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_2_TO_3";
    /**
     * 継続期間が4~6ヶ月のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_4_TO_6 = 4;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_4_TO_6"] = 4] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_4_TO_6";
    /**
     * 継続期間が7~12ヶ月のグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_7_TO_12 = 5;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_7_TO_12"] = 5] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_7_TO_12";
    /**
     * 継続期間が12ヶ月より大きいグラフラベル値
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_MORE_THAN_12 = 6;
     */
    CMSDashboardGraphConsecutivePeriod[CMSDashboardGraphConsecutivePeriod["CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_MORE_THAN_12"] = 6] = "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_MORE_THAN_12";
})(CMSDashboardGraphConsecutivePeriod = exports.CMSDashboardGraphConsecutivePeriod || (exports.CMSDashboardGraphConsecutivePeriod = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphConsecutivePeriod)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphConsecutivePeriod, "spwn.dashboard.v1.CMSDashboardGraphConsecutivePeriod", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_LESS_THAN_1" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_1" },
    { no: 3, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_2_TO_3" },
    { no: 4, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_4_TO_6" },
    { no: 5, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_FROM_7_TO_12" },
    { no: 6, name: "CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_MORE_THAN_12" },
]);
/**
 * goodsの購入額別の購入人数のbin幅のtype1
 *
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphPurchaseAmount
 */
var CMSDashboardGraphPurchaseAmount;
(function (CMSDashboardGraphPurchaseAmount) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_UNSPECIFIED = 0;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_UNSPECIFIED";
    /**
     * 購入額が0~1999円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_0_TO_1999 = 1;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_0_TO_1999"] = 1] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_0_TO_1999";
    /**
     * 購入額が2000~3999円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_2000_TO_3999 = 2;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_2000_TO_3999"] = 2] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_2000_TO_3999";
    /**
     * 購入額が4000~5999円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_4000_TO_5999 = 3;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_4000_TO_5999"] = 3] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_4000_TO_5999";
    /**
     * 購入額が6000~7999円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_6000_TO_7999 = 4;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_6000_TO_7999"] = 4] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_6000_TO_7999";
    /**
     * 購入額が8000~9999円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_8000_TO_9999 = 5;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_8000_TO_9999"] = 5] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_8000_TO_9999";
    /**
     * 購入額が10000~円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_OVER_10000 = 6;
     */
    CMSDashboardGraphPurchaseAmount[CMSDashboardGraphPurchaseAmount["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_OVER_10000"] = 6] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_OVER_10000";
})(CMSDashboardGraphPurchaseAmount = exports.CMSDashboardGraphPurchaseAmount || (exports.CMSDashboardGraphPurchaseAmount = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphPurchaseAmount)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphPurchaseAmount, "spwn.dashboard.v1.CMSDashboardGraphPurchaseAmount", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_0_TO_1999" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_2000_TO_3999" },
    { no: 3, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_4000_TO_5999" },
    { no: 4, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_6000_TO_7999" },
    { no: 5, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_FROM_8000_TO_9999" },
    { no: 6, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_OVER_10000" },
]);
/**
 * goodsの購入額別の購入人数のbin幅のtype2 (現状はtype2のみ使用)
 * FIXME: type1, type2両方を使用するようになったら関連コードの修正
 *
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphPurchaseAmountType2
 */
var CMSDashboardGraphPurchaseAmountType2;
(function (CMSDashboardGraphPurchaseAmountType2) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_UNSPECIFIED = 0;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_UNSPECIFIED";
    /**
     * 購入額が0~500円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_0_TO_500 = 1;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_0_TO_500"] = 1] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_0_TO_500";
    /**
     * 購入額が501~1200円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_501_TO_1200 = 2;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_501_TO_1200"] = 2] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_501_TO_1200";
    /**
     * 購入額が1201~2000円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_1201_TO_2000 = 3;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_1201_TO_2000"] = 3] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_1201_TO_2000";
    /**
     * 購入額が2001~5000円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_2001_TO_5000 = 4;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_2001_TO_5000"] = 4] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_2001_TO_5000";
    /**
     * 購入額が5001~10000円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_5001_TO_10000 = 5;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_5001_TO_10000"] = 5] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_5001_TO_10000";
    /**
     * 購入額が10001~50000円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_10001_TO_50000 = 6;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_10001_TO_50000"] = 6] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_10001_TO_50000";
    /**
     * 購入額が50001~100000円のユーザー数
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_50001_TO_100000 = 7;
     */
    CMSDashboardGraphPurchaseAmountType2[CMSDashboardGraphPurchaseAmountType2["CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_50001_TO_100000"] = 7] = "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_50001_TO_100000";
})(CMSDashboardGraphPurchaseAmountType2 = exports.CMSDashboardGraphPurchaseAmountType2 || (exports.CMSDashboardGraphPurchaseAmountType2 = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphPurchaseAmountType2)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphPurchaseAmountType2, "spwn.dashboard.v1.CMSDashboardGraphPurchaseAmountType2", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_0_TO_500" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_501_TO_1200" },
    { no: 3, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_1201_TO_2000" },
    { no: 4, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_2001_TO_5000" },
    { no: 5, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_5001_TO_10000" },
    { no: 6, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_10001_TO_50000" },
    { no: 7, name: "CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_FROM_50001_TO_100000" },
]);
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphGroupId
 */
var CMSDashboardGraphGroupId;
(function (CMSDashboardGraphGroupId) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GROUP_ID_UNSPECIFIED = 0;
     */
    CMSDashboardGraphGroupId[CMSDashboardGraphGroupId["CMS_DASHBOARD_GRAPH_GROUP_ID_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_GROUP_ID_UNSPECIFIED";
    /**
     * ファンクラブ分析のグラフグループのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GROUP_ID_FANCLUB = 1;
     */
    CMSDashboardGraphGroupId[CMSDashboardGraphGroupId["CMS_DASHBOARD_GRAPH_GROUP_ID_FANCLUB"] = 1] = "CMS_DASHBOARD_GRAPH_GROUP_ID_FANCLUB";
    /**
     * グッズ販売分析のグラフグループのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_GROUP_ID_GOODS = 2;
     */
    CMSDashboardGraphGroupId[CMSDashboardGraphGroupId["CMS_DASHBOARD_GRAPH_GROUP_ID_GOODS"] = 2] = "CMS_DASHBOARD_GRAPH_GROUP_ID_GOODS";
})(CMSDashboardGraphGroupId = exports.CMSDashboardGraphGroupId || (exports.CMSDashboardGraphGroupId = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphGroupId)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphGroupId, "spwn.dashboard.v1.CMSDashboardGraphGroupId", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_GROUP_ID_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_GROUP_ID_FANCLUB" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_GROUP_ID_GOODS" },
]);
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphId
 */
var CMSDashboardGraphId;
(function (CMSDashboardGraphId) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_UNSPECIFIED = 0;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_ID_UNSPECIFIED";
    /**
     * ファンクラブ加入者数のグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_FANCLUB_SUBSCRIBERS = 1;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_FANCLUB_SUBSCRIBERS"] = 1] = "CMS_DASHBOARD_GRAPH_ID_FANCLUB_SUBSCRIBERS";
    /**
     * ファンクラブ加入者から得られる売り上げのグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_FANCLUB_SALES = 2;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_FANCLUB_SALES"] = 2] = "CMS_DASHBOARD_GRAPH_ID_FANCLUB_SALES";
    /**
     * ファンクラブ加入者を年齢性別で集計したグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_FANCLUB_AGE_GENDER = 3;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_FANCLUB_AGE_GENDER"] = 3] = "CMS_DASHBOARD_GRAPH_ID_FANCLUB_AGE_GENDER";
    /**
     * ファンクラブ加入者を継続月別で集計したグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_FANCLUB_CONSECUTIVE = 4;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_FANCLUB_CONSECUTIVE"] = 4] = "CMS_DASHBOARD_GRAPH_ID_FANCLUB_CONSECUTIVE";
    /**
     * グッズを購入者数のグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_GOODS_PURCHASERS = 5;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_GOODS_PURCHASERS"] = 5] = "CMS_DASHBOARD_GRAPH_ID_GOODS_PURCHASERS";
    /**
     * グッズ売り上げのグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_GOODS_SALES = 6;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_GOODS_SALES"] = 6] = "CMS_DASHBOARD_GRAPH_ID_GOODS_SALES";
    /**
     * グッズ購入購入者を年齢性別で集計したグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_GOODS_AGE_GENDER = 7;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_GOODS_AGE_GENDER"] = 7] = "CMS_DASHBOARD_GRAPH_ID_GOODS_AGE_GENDER";
    /**
     * グッズ購入購入者を購入額別に集計したグラフのID
     *
     * @generated from enum value: CMS_DASHBOARD_GRAPH_ID_GOODS_PEOPLE_BY_PURCHASE = 8;
     */
    CMSDashboardGraphId[CMSDashboardGraphId["CMS_DASHBOARD_GRAPH_ID_GOODS_PEOPLE_BY_PURCHASE"] = 8] = "CMS_DASHBOARD_GRAPH_ID_GOODS_PEOPLE_BY_PURCHASE";
})(CMSDashboardGraphId = exports.CMSDashboardGraphId || (exports.CMSDashboardGraphId = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphId)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphId, "spwn.dashboard.v1.CMSDashboardGraphId", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_ID_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_ID_FANCLUB_SUBSCRIBERS" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_ID_FANCLUB_SALES" },
    { no: 3, name: "CMS_DASHBOARD_GRAPH_ID_FANCLUB_AGE_GENDER" },
    { no: 4, name: "CMS_DASHBOARD_GRAPH_ID_FANCLUB_CONSECUTIVE" },
    { no: 5, name: "CMS_DASHBOARD_GRAPH_ID_GOODS_PURCHASERS" },
    { no: 6, name: "CMS_DASHBOARD_GRAPH_ID_GOODS_SALES" },
    { no: 7, name: "CMS_DASHBOARD_GRAPH_ID_GOODS_AGE_GENDER" },
    { no: 8, name: "CMS_DASHBOARD_GRAPH_ID_GOODS_PEOPLE_BY_PURCHASE" },
]);
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardGraphCommentColor
 */
var CMSDashboardGraphCommentColor;
(function (CMSDashboardGraphCommentColor) {
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_COMMENT_COLOR_UNSPECIFIED = 0;
     */
    CMSDashboardGraphCommentColor[CMSDashboardGraphCommentColor["CMS_DASHBOARD_GRAPH_COMMENT_COLOR_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_GRAPH_COMMENT_COLOR_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_COMMENT_COLOR_GREEN = 1;
     */
    CMSDashboardGraphCommentColor[CMSDashboardGraphCommentColor["CMS_DASHBOARD_GRAPH_COMMENT_COLOR_GREEN"] = 1] = "CMS_DASHBOARD_GRAPH_COMMENT_COLOR_GREEN";
    /**
     * @generated from enum value: CMS_DASHBOARD_GRAPH_COMMENT_COLOR_RED = 2;
     */
    CMSDashboardGraphCommentColor[CMSDashboardGraphCommentColor["CMS_DASHBOARD_GRAPH_COMMENT_COLOR_RED"] = 2] = "CMS_DASHBOARD_GRAPH_COMMENT_COLOR_RED";
})(CMSDashboardGraphCommentColor = exports.CMSDashboardGraphCommentColor || (exports.CMSDashboardGraphCommentColor = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardGraphCommentColor)
protobuf_1.proto3.util.setEnumType(CMSDashboardGraphCommentColor, "spwn.dashboard.v1.CMSDashboardGraphCommentColor", [
    { no: 0, name: "CMS_DASHBOARD_GRAPH_COMMENT_COLOR_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_GRAPH_COMMENT_COLOR_GREEN" },
    { no: 2, name: "CMS_DASHBOARD_GRAPH_COMMENT_COLOR_RED" },
]);
/**
 * @generated from enum spwn.dashboard.v1.CMSDashboardCommentLinkId
 */
var CMSDashboardCommentLinkId;
(function (CMSDashboardCommentLinkId) {
    /**
     * @generated from enum value: CMS_DASHBOARD_COMMENT_LINK_ID_UNSPECIFIED = 0;
     */
    CMSDashboardCommentLinkId[CMSDashboardCommentLinkId["CMS_DASHBOARD_COMMENT_LINK_ID_UNSPECIFIED"] = 0] = "CMS_DASHBOARD_COMMENT_LINK_ID_UNSPECIFIED";
    /**
     * Xで宣伝するリンク
     *
     * @generated from enum value: CMS_DASHBOARD_COMMENT_LINK_ID_PROMOTE_BY_X = 1;
     */
    CMSDashboardCommentLinkId[CMSDashboardCommentLinkId["CMS_DASHBOARD_COMMENT_LINK_ID_PROMOTE_BY_X"] = 1] = "CMS_DASHBOARD_COMMENT_LINK_ID_PROMOTE_BY_X";
    /**
     * プランを編集するリンク
     *
     * @generated from enum value: CMS_DASHBOARD_COMMENT_LINK_ID_EDIT_PLAN = 2;
     */
    CMSDashboardCommentLinkId[CMSDashboardCommentLinkId["CMS_DASHBOARD_COMMENT_LINK_ID_EDIT_PLAN"] = 2] = "CMS_DASHBOARD_COMMENT_LINK_ID_EDIT_PLAN";
    /**
     * コンテンツを投稿するリンク
     *
     * @generated from enum value: CMS_DASHBOARD_COMMENT_LINK_ID_POST_CONTENT = 3;
     */
    CMSDashboardCommentLinkId[CMSDashboardCommentLinkId["CMS_DASHBOARD_COMMENT_LINK_ID_POST_CONTENT"] = 3] = "CMS_DASHBOARD_COMMENT_LINK_ID_POST_CONTENT";
    /**
     * グッズを作成するリンク
     *
     * @generated from enum value: CMS_DASHBOARD_COMMENT_LINK_ID_CREATE_GOODS = 4;
     */
    CMSDashboardCommentLinkId[CMSDashboardCommentLinkId["CMS_DASHBOARD_COMMENT_LINK_ID_CREATE_GOODS"] = 4] = "CMS_DASHBOARD_COMMENT_LINK_ID_CREATE_GOODS";
    /**
     * グッズを管理するリンク
     *
     * @generated from enum value: CMS_DASHBOARD_COMMENT_LINK_ID_MANAGE_GOODS = 5;
     */
    CMSDashboardCommentLinkId[CMSDashboardCommentLinkId["CMS_DASHBOARD_COMMENT_LINK_ID_MANAGE_GOODS"] = 5] = "CMS_DASHBOARD_COMMENT_LINK_ID_MANAGE_GOODS";
})(CMSDashboardCommentLinkId = exports.CMSDashboardCommentLinkId || (exports.CMSDashboardCommentLinkId = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSDashboardCommentLinkId)
protobuf_1.proto3.util.setEnumType(CMSDashboardCommentLinkId, "spwn.dashboard.v1.CMSDashboardCommentLinkId", [
    { no: 0, name: "CMS_DASHBOARD_COMMENT_LINK_ID_UNSPECIFIED" },
    { no: 1, name: "CMS_DASHBOARD_COMMENT_LINK_ID_PROMOTE_BY_X" },
    { no: 2, name: "CMS_DASHBOARD_COMMENT_LINK_ID_EDIT_PLAN" },
    { no: 3, name: "CMS_DASHBOARD_COMMENT_LINK_ID_POST_CONTENT" },
    { no: 4, name: "CMS_DASHBOARD_COMMENT_LINK_ID_CREATE_GOODS" },
    { no: 5, name: "CMS_DASHBOARD_COMMENT_LINK_ID_MANAGE_GOODS" },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardYoutubeAccount
 */
class CMSDashboardYoutubeAccount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * youtube_accountとbrandは1対1の関係
         *
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * yotuube apiを利用するのに必要なtokenを生成するためのrefresh token
         *
         * @generated from field: string refresh_token = 2;
         */
        this.refreshToken = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardYoutubeAccount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardYoutubeAccount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardYoutubeAccount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardYoutubeAccount, a, b);
    }
}
exports.CMSDashboardYoutubeAccount = CMSDashboardYoutubeAccount;
CMSDashboardYoutubeAccount.runtime = protobuf_1.proto3;
CMSDashboardYoutubeAccount.typeName = "spwn.dashboard.v1.CMSDashboardYoutubeAccount";
CMSDashboardYoutubeAccount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "refresh_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGraphGroup
 */
class CMSDashboardGraphGroup extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * dashboardのgroupのID
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphGroupId group_id = 1;
         */
        this.groupId = CMSDashboardGraphGroupId.CMS_DASHBOARD_GRAPH_GROUP_ID_UNSPECIFIED;
        /**
         * groupに属するgraphのarray
         *
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardGraph graphs = 3;
         */
        this.graphs = [];
        /**
         * groupの表示順
         *
         * @generated from field: int32 position = 4;
         */
        this.position = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGraphGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGraphGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGraphGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGraphGroup, a, b);
    }
}
exports.CMSDashboardGraphGroup = CMSDashboardGraphGroup;
CMSDashboardGraphGroup.runtime = protobuf_1.proto3;
CMSDashboardGraphGroup.typeName = "spwn.dashboard.v1.CMSDashboardGraphGroup";
CMSDashboardGraphGroup.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "group_id", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphGroupId) },
    { no: 2, name: "comment", kind: "message", T: CMSDashboardGraphComment },
    { no: 3, name: "graphs", kind: "message", T: CMSDashboardGraph, repeated: true },
    { no: 4, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGraphTimeSeriesValue
 */
class CMSDashboardGraphTimeSeriesValue extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 時系列値の日時情報
         *
         * @generated from field: int64 date = 1;
         */
        this.date = protobuf_1.protoInt64.zero;
        /**
         * 時系列値の値情報
         *
         * @generated from field: int32 value = 2;
         */
        this.value = 0;
        /**
         * 値が予測値であるか否か
         *
         * @generated from field: bool is_estimated_value = 3;
         */
        this.isEstimatedValue = false;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGraphTimeSeriesValue().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGraphTimeSeriesValue().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGraphTimeSeriesValue().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGraphTimeSeriesValue, a, b);
    }
}
exports.CMSDashboardGraphTimeSeriesValue = CMSDashboardGraphTimeSeriesValue;
CMSDashboardGraphTimeSeriesValue.runtime = protobuf_1.proto3;
CMSDashboardGraphTimeSeriesValue.typeName = "spwn.dashboard.v1.CMSDashboardGraphTimeSeriesValue";
CMSDashboardGraphTimeSeriesValue.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "value", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "is_estimated_value", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGraphTimeSeries
 */
class CMSDashboardGraphTimeSeries extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 時系列グラフ
         *
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardGraphTimeSeriesValue values = 1;
         */
        this.values = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGraphTimeSeries().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGraphTimeSeries().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGraphTimeSeries().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGraphTimeSeries, a, b);
    }
}
exports.CMSDashboardGraphTimeSeries = CMSDashboardGraphTimeSeries;
CMSDashboardGraphTimeSeries.runtime = protobuf_1.proto3;
CMSDashboardGraphTimeSeries.typeName = "spwn.dashboard.v1.CMSDashboardGraphTimeSeries";
CMSDashboardGraphTimeSeries.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "message", T: CMSDashboardGraphTimeSeriesValue, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardConsecutivePeriodHistogramBin
 */
class CMSDashboardConsecutivePeriodHistogramBin extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 　継続期間ヒストグラムのビンの頻度数
         *
         * @generated from field: int32 count = 1;
         */
        this.count = 0;
        /**
         * 　継続期間ヒストグラムのビンの継続期間ラベル
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphConsecutivePeriod graph_consecutive_period = 2;
         */
        this.graphConsecutivePeriod = CMSDashboardGraphConsecutivePeriod.CMS_DASHBOARD_GRAPH_CONSECUTIVE_PERIOD_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardConsecutivePeriodHistogramBin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardConsecutivePeriodHistogramBin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardConsecutivePeriodHistogramBin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardConsecutivePeriodHistogramBin, a, b);
    }
}
exports.CMSDashboardConsecutivePeriodHistogramBin = CMSDashboardConsecutivePeriodHistogramBin;
CMSDashboardConsecutivePeriodHistogramBin.runtime = protobuf_1.proto3;
CMSDashboardConsecutivePeriodHistogramBin.typeName = "spwn.dashboard.v1.CMSDashboardConsecutivePeriodHistogramBin";
CMSDashboardConsecutivePeriodHistogramBin.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "graph_consecutive_period", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphConsecutivePeriod) },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGraphConsecutivePeriodHistogram
 */
class CMSDashboardGraphConsecutivePeriodHistogram extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 　継続期間グラフのヒストグラム
         *
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardConsecutivePeriodHistogramBin bins = 1;
         */
        this.bins = [];
        /**
         * 継続期間の平均値
         *
         * @generated from field: float average = 2;
         */
        this.average = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGraphConsecutivePeriodHistogram().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGraphConsecutivePeriodHistogram().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGraphConsecutivePeriodHistogram().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGraphConsecutivePeriodHistogram, a, b);
    }
}
exports.CMSDashboardGraphConsecutivePeriodHistogram = CMSDashboardGraphConsecutivePeriodHistogram;
CMSDashboardGraphConsecutivePeriodHistogram.runtime = protobuf_1.proto3;
CMSDashboardGraphConsecutivePeriodHistogram.typeName = "spwn.dashboard.v1.CMSDashboardGraphConsecutivePeriodHistogram";
CMSDashboardGraphConsecutivePeriodHistogram.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bins", kind: "message", T: CMSDashboardConsecutivePeriodHistogramBin, repeated: true },
    { no: 2, name: "average", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGenderAgeHistogramBin
 */
class CMSDashboardGenderAgeHistogramBin extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 年齢性別ヒストグラムのビンの年齢ラベル
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphAgeGroup age_range = 1;
         */
        this.ageRange = CMSDashboardGraphAgeGroup.CMS_DASHBOARD_GRAPH_AGE_GROUP_UNSPECIFIED;
        /**
         * 年齢性別ヒストグラムのビンの性別ラベル
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphGender gender = 2;
         */
        this.gender = CMSDashboardGraphGender.CMS_DASHBOARD_GRAPH_GENDER_UNSPECIFIED;
        /**
         * 年齢性別ヒストグラムのビンの頻度数
         *
         * @generated from field: int32 count = 3;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGenderAgeHistogramBin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGenderAgeHistogramBin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGenderAgeHistogramBin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGenderAgeHistogramBin, a, b);
    }
}
exports.CMSDashboardGenderAgeHistogramBin = CMSDashboardGenderAgeHistogramBin;
CMSDashboardGenderAgeHistogramBin.runtime = protobuf_1.proto3;
CMSDashboardGenderAgeHistogramBin.typeName = "spwn.dashboard.v1.CMSDashboardGenderAgeHistogramBin";
CMSDashboardGenderAgeHistogramBin.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "age_range", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphAgeGroup) },
    { no: 2, name: "gender", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphGender) },
    { no: 3, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGenderAgeHistogram
 */
class CMSDashboardGenderAgeHistogram extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 年齢性別ヒストグラム
         *
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardGenderAgeHistogramBin bins = 1;
         */
        this.bins = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGenderAgeHistogram().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGenderAgeHistogram().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGenderAgeHistogram().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGenderAgeHistogram, a, b);
    }
}
exports.CMSDashboardGenderAgeHistogram = CMSDashboardGenderAgeHistogram;
CMSDashboardGenderAgeHistogram.runtime = protobuf_1.proto3;
CMSDashboardGenderAgeHistogram.typeName = "spwn.dashboard.v1.CMSDashboardGenderAgeHistogram";
CMSDashboardGenderAgeHistogram.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bins", kind: "message", T: CMSDashboardGenderAgeHistogramBin, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardPurchaseAmountHistogramBin
 */
class CMSDashboardPurchaseAmountHistogramBin extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 購入額の範囲ラベル
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphPurchaseAmountType2 purchase_amount = 1;
         */
        this.purchaseAmount = CMSDashboardGraphPurchaseAmountType2.CMS_DASHBOARD_GRAPH_PURCHASE_AMOUNT_TYPE2_UNSPECIFIED;
        /**
         * 購入額の範囲に該当する人数
         *
         * @generated from field: int32 count = 2;
         */
        this.count = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardPurchaseAmountHistogramBin().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardPurchaseAmountHistogramBin().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardPurchaseAmountHistogramBin().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardPurchaseAmountHistogramBin, a, b);
    }
}
exports.CMSDashboardPurchaseAmountHistogramBin = CMSDashboardPurchaseAmountHistogramBin;
CMSDashboardPurchaseAmountHistogramBin.runtime = protobuf_1.proto3;
CMSDashboardPurchaseAmountHistogramBin.typeName = "spwn.dashboard.v1.CMSDashboardPurchaseAmountHistogramBin";
CMSDashboardPurchaseAmountHistogramBin.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "purchase_amount", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphPurchaseAmountType2) },
    { no: 2, name: "count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardPurchaseAmountHistogram
 */
class CMSDashboardPurchaseAmountHistogram extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 購入額ヒストグラムのbin
         *
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardPurchaseAmountHistogramBin bins = 1;
         */
        this.bins = [];
        /**
         * 購入額の平均値
         *
         * @generated from field: int32 average = 2;
         */
        this.average = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardPurchaseAmountHistogram().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardPurchaseAmountHistogram().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardPurchaseAmountHistogram().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardPurchaseAmountHistogram, a, b);
    }
}
exports.CMSDashboardPurchaseAmountHistogram = CMSDashboardPurchaseAmountHistogram;
CMSDashboardPurchaseAmountHistogram.runtime = protobuf_1.proto3;
CMSDashboardPurchaseAmountHistogram.typeName = "spwn.dashboard.v1.CMSDashboardPurchaseAmountHistogram";
CMSDashboardPurchaseAmountHistogram.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bins", kind: "message", T: CMSDashboardPurchaseAmountHistogramBin, repeated: true },
    { no: 2, name: "average", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGraph
 */
class CMSDashboardGraph extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * dashboardのgraphのid
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphId graph_id = 1;
         */
        this.graphId = CMSDashboardGraphId.CMS_DASHBOARD_GRAPH_ID_UNSPECIFIED;
        /**
         * graphの表示順
         *
         * @generated from field: int32 position = 2;
         */
        this.position = 0;
        /**
         * graphのグラフ描画に必要なデータ値, グラフによって使い分ける
         *
         * @generated from oneof spwn.dashboard.v1.CMSDashboardGraph.graph_value
         */
        this.graphValue = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGraph().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGraph().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGraph().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGraph, a, b);
    }
}
exports.CMSDashboardGraph = CMSDashboardGraph;
CMSDashboardGraph.runtime = protobuf_1.proto3;
CMSDashboardGraph.typeName = "spwn.dashboard.v1.CMSDashboardGraph";
CMSDashboardGraph.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "graph_id", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphId) },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "time_series_graph", kind: "message", T: CMSDashboardGraphTimeSeries, oneof: "graph_value" },
    { no: 4, name: "gender_age_histogram", kind: "message", T: CMSDashboardGenderAgeHistogram, oneof: "graph_value" },
    { no: 5, name: "consecutive_period_histogram", kind: "message", T: CMSDashboardGraphConsecutivePeriodHistogram, oneof: "graph_value" },
    { no: 6, name: "purchase_amount_histogram", kind: "message", T: CMSDashboardPurchaseAmountHistogram, oneof: "graph_value" },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGraphComment
 */
class CMSDashboardGraphComment extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * コメントの見出し
         *
         * @generated from field: string title = 1;
         */
        this.title = "";
        /**
         * コメントの本文
         *
         * @generated from field: string body = 2;
         */
        this.body = "";
        /**
         * コメントの色
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardGraphCommentColor color = 3;
         */
        this.color = CMSDashboardGraphCommentColor.CMS_DASHBOARD_GRAPH_COMMENT_COLOR_UNSPECIFIED;
        /**
         * コメントのリンク
         *
         * @generated from field: spwn.dashboard.v1.CMSDashboardCommentLinkId link = 4;
         */
        this.link = CMSDashboardCommentLinkId.CMS_DASHBOARD_COMMENT_LINK_ID_UNSPECIFIED;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGraphComment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGraphComment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGraphComment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGraphComment, a, b);
    }
}
exports.CMSDashboardGraphComment = CMSDashboardGraphComment;
CMSDashboardGraphComment.runtime = protobuf_1.proto3;
CMSDashboardGraphComment.typeName = "spwn.dashboard.v1.CMSDashboardGraphComment";
CMSDashboardGraphComment.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphCommentColor) },
    { no: 4, name: "link", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardCommentLinkId) },
    { no: 5, name: "graph_id", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSDashboardGraphId), opt: true },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardPlan
 */
class CMSDashboardPlan extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファンクラブのプランのfirestore id
         *
         * @generated from field: string plan_firestore_id = 1;
         */
        this.planFirestoreId = "";
        /**
         * ファンクラブのプランの名前
         *
         * @generated from field: string plan_name = 2;
         */
        this.planName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardPlan().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardPlan().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardPlan().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardPlan, a, b);
    }
}
exports.CMSDashboardPlan = CMSDashboardPlan;
CMSDashboardPlan.runtime = protobuf_1.proto3;
CMSDashboardPlan.typeName = "spwn.dashboard.v1.CMSDashboardPlan";
CMSDashboardPlan.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "plan_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * dashboardのグッズ販売グラフグループのフィルターで用いる
 *
 * @generated from message spwn.dashboard.v1.CMSDashboardGoods
 */
class CMSDashboardGoods extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファンクラブグッズのid
         *
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * ファンクラブグッズの名前
         *
         * @generated from field: string goods_name = 2;
         */
        this.goodsName = "";
        /**
         * ファンクラブグッズのvariantsの配列
         *
         * @generated from field: repeated spwn.dashboard.v1.CMSDashboardGoodsVariant variants = 3;
         */
        this.variants = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGoods().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGoods().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGoods().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGoods, a, b);
    }
}
exports.CMSDashboardGoods = CMSDashboardGoods;
CMSDashboardGoods.runtime = protobuf_1.proto3;
CMSDashboardGoods.typeName = "spwn.dashboard.v1.CMSDashboardGoods";
CMSDashboardGoods.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "goods_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "variants", kind: "message", T: CMSDashboardGoodsVariant, repeated: true },
]);
/**
 * @generated from message spwn.dashboard.v1.CMSDashboardGoodsVariant
 */
class CMSDashboardGoodsVariant extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * ファンクラブグッズのvariantのid
         *
         * @generated from field: string variant_id = 1;
         */
        this.variantId = "";
        /**
         * ファンクラブグッズのvariantの名前
         *
         * @generated from field: string variant_name = 2;
         */
        this.variantName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSDashboardGoodsVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSDashboardGoodsVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSDashboardGoodsVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSDashboardGoodsVariant, a, b);
    }
}
exports.CMSDashboardGoodsVariant = CMSDashboardGoodsVariant;
CMSDashboardGoodsVariant.runtime = protobuf_1.proto3;
CMSDashboardGoodsVariant.typeName = "spwn.dashboard.v1.CMSDashboardGoodsVariant";
CMSDashboardGoodsVariant.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "variant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "variant_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=cms_common_pb.js.map